import React from "react";
import { Card, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";

// Import your Report page images
import payrollimg from "assets/images/payroll.png";
import attendance from "assets/images/attendance.png";
import hiringimg from "assets/images/hiringimg.png";
import skillsReport from "assets/images/skillsReport.png";
import offerLetter from "assets/images/offerLetter.png";
import leave from "assets/images/leave.png";

// Map images to your original cards
const cardData = [
  { img: payrollimg, title: "Spec Recruiting", to: "/specRecruitment" },
  { img: attendance, title: "Sync Recruiting", to: "/recruitment-Integration" },
  { img: leave, title: "Offer Letters", to: "/offerLetters" },
  { img: hiringimg, title: "Performance", to: "/performance" },
  { img: skillsReport, title: "Reports", to: "/report" },
];

// Premium gradient classes from first Report page
const docCardClasses = [
  "doc-card-1",
  "doc-card-2",
  "doc-card-3",
  "doc-card-4",
  "doc-card-5",
  "doc-card-6",
  "doc-card-7",
];

export default function DocumentCards() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "15px" }}>
      <Row gutter={[20, 20]} justify="center">
        {cardData.map(({ img, title, to }, index) => {
          const cardClass = docCardClasses[index % docCardClasses.length];

          return (
            <Col xs={24} sm={12} md={8} lg={6} xl={4.8} key={index}>
              <div
                onClick={() => navigate(to)}
                style={{ cursor: "pointer" }}
              >
                <Card className={`pro-green-card ${cardClass}`}>
                  <div className="pro-card-content" style={{ textAlign: "center" }}>
                    <div className="card-icon">
                      <img
                        src={img}
                        alt={title}
                        style={{
                          height: "50px",
                          filter: "brightness(0) invert(1)",
                          marginBottom: "10px",
                        }}
                      />
                    </div>
                    <h3>{title}</h3>
                  </div>
                </Card>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}